import React, {Component} from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export default class WYSIWYG extends Component {
  constructor(props) {
    super(props);
    const contentBlock = htmlToDraft(props.value);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
        value: '',
        loaded: false,
      };
    }

    this.onEditorStateChange = this.onEditorStateChange.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.value !== this.props.value && this.state.loaded === false) {
      const contentBlock = htmlToDraft(nextProps.value);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          value: nextProps.value,
          editorState,
          loaded: true,
        });
      }
    }

    return true;
  }

  onEditorStateChange(editorState) {
    const {onChange, name} = this.props;

    this.setState({
      editorState,
    });

    onChange(name, draftToHtml(convertToRaw(editorState.getCurrentContent())))
  }

  render() {
    const { editorState, value } = this.state;

    return (
      <div>
        <Editor
          editorState={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          onEditorStateChange={this.onEditorStateChange}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WYSIWYG/WYSIWYG.js